import { BehaviorSubject, first, Observable } from 'rxjs';
import { isPlatformBrowser } from "@angular/common";
import { inject, Inject, Injectable, PLATFORM_ID, ApplicationRef, OnDestroy, NgZone } from "@angular/core";
import { io, Socket } from 'socket.io-client';
import * as globalConstant from './../global_constant';
import { fromEvent, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService implements OnDestroy {
  public socket: Socket;
  isBrowser: Boolean;
  apiDomain = globalConstant.DOMAIN;
  domain = "https://node.spurexperiences.com";
  // domain = "https://newstagenode.spurexperiences.com";

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object, 
    private ngZone: NgZone,
    private applicationRef: ApplicationRef
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  
    if (this.isBrowser) {
      this.socket = io(this.domain, {
        autoConnect: false,
        transports: ['websocket', 'polling'],
      });
  
      this.applicationRef.isStable
        .pipe(first((isStable) => isStable))
        .subscribe(() => {
          this.socket.connect();
          //console.log('this.socket11', this.socket);
        });
    }
  }
  
  connect() {
    if (this.isBrowser) {
      // console.log('Trying to connect...');
      this.socket.connect();
    }
  }

  listen(eventName: string): Observable<any> {
    return new Observable(subscriber => {
      this.socket?.on(eventName, (data: any) => {
        subscriber.next(data);
      });
    });
  }

  listenAdmin(eventName: string): Observable<any> {
      return new Observable(subscriber => {
        this.socket?.on(eventName, (data: any) => {
          subscriber.next(data);
        });
      });
  }

  listenTyping(eventName: string): Observable<any> {
    return new Observable(subscriber => {
      this.socket?.on(eventName, (data: any) => {
        subscriber.next(data);
      });
    });
  }

  listenUnread(eventName: string): Observable<any> {
    return new Observable(subscriber => {
      this.socket?.on(eventName, (data: any) => {
        subscriber.next(data);
      });
    });
  }

  public emit(eventName: string, data: any): void {
    this.socket?.emit(eventName, data);
  }

  async emitWithConnectionWait(eventName: string, data: any, timeoutMs: number = 10000): Promise<void> {
    if (!this.socket?.connected) {
      // Wait for connection with timeout protection
      const connectionPromise = new Promise<void>((resolve) => {
        this.socket.once('connect', () => resolve());
      });
      
      const timeoutPromise = new Promise<void>((_, reject) => {
        setTimeout(() => reject(new Error('Socket connection timeout')), timeoutMs);
      });
      
      await Promise.race([connectionPromise, timeoutPromise]);
    }
    this.socket.emit(eventName, data);
  }

  ngOnDestroy(): void {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
